module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-6.b1f7b9a4.png";